module.exports = __webpack_public_path__ + "static/media/0093_Medium.69d5681c.jpg";